import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaOrdersMenuRegistry = {
    personalize_nebulaOrders: {
        label: "Nebula Orders",
        link: PAGE_URL.NEBULA_ORDERS_PAGE,
        key: PAGE_URL.NEBULA_ORDERS_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaOrdersMenuRegistry;
